import { SortItem } from '../ss-api/responses/member.dashboard.license.response';

export enum LogTypes {
    // member
    EditMember = 0,
    LoginAsMember = 1,
    MergeMember = 2,

    // license
    EditLicense = 50,
    AddLicenseAsMember = 51,

    // invoice
    Invoice = 100,

    // billing
    DeleteCredit = 150,

    // credit cards
    AddCreditCard = 200,
    DeleteCreditCard = 210,
    MakeCreditCardDefault = 220,
    HideCreditCard = 230,
    ActivateCreditCard = 240,
    EditCreditCard = 250,
}

export class AdminLogItem {
    ID: number;
    LogType: LogTypes;
    Subject: string;
    Description: string;
    DateTimeCreated: Date;
    Admin_ID: number;
    AdminFullName: string;
    Member_ID: number;
    License_ID: number;
    LicenseKey: string;
    MemberService_ID: number;
    Invoice_ID: number;
    HasNotes: boolean;

    public static FixDate(item: AdminLogItem) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }
}

export class AdminLogItemArray extends Array<AdminLogItem>  {
    public LastSort = new SortItem;

    constructor(...items: AdminLogItem[]) {
        super(...items);
        Object.setPrototypeOf(this, AdminLogItemArray.prototype);
    }


    public static FixDates(items: AdminLogItemArray) {
        items.forEach(x => AdminLogItem.FixDate(x));
    }

    public static SortByDate( sortThis: AdminLogItemArray ): AdminLogItemArray {
        sortThis.sort((a, b) => {
            if (a.ID > b.ID ) return -1;
            else if (a.ID < b.ID) return 1;
            else return 0;
        });

        return sortThis;
    }

}
